import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'partcfrontend';
  currentUserPanelTab = "users";
  currentContentPanelTab = "users";
  userIsActive = false;
  groupIsActive = false;
  userInfoActive = false;
  groupInfoActive = false;
  activeUser: any;
  activeGroup: any;
  serviceDrawerOpen = false;
  userCASImportActive = false;
  roleNameSave = false;
  usersList = [
    {
      id: 1,
      name: "Bita",
      lastName: "Mortazavi",
      city: "Geneva",
      birthday: "12.12.1212",
      group: [1, 3, 5]
    },
    {
      id: 2,
      name: "Johannes",
      lastName: "Tamm",
      city: "Tartu",
      birthday: "12.12.1212",
      group: [2, 3, 5]
    },
    {
      id: 3,
      name: "Erick",
      lastName: "León Bolinaga",
      city: "La Habana",
      birthday: "27.10.1987",
      group: [1, 3, 6]
    },
    {
      id: 4,
      name: "Claudia",
      lastName: "Cáceres",
      city: "",
      birthday: "12.12.1212",
      group: [3, 4, 5]
    },
    {
      id: 5,
      name: "Frank",
      lastName: "Grozel   ",
      city: "Geneva",
      birthday: "12.12.1212",
      group: [1, 3, 5]
    },
    {
      id: 6,
      name: "Erki",
      lastName: "Kirks",
      city: "Tallinn",
      birthday: "12.12.1212",
      group: [1, 4, 6]
    },
    {
      id: 7,
      name: "Nelson",
      lastName: "Pérez",
      city: "San Salvador",
      birthday: "12.12.1212",
      group: [2, 3, 4]
    },
    {
      id: 8,
      name: "Super",
      lastName: "Mario",
      city: "",
      birthday: "12.12.1212",
      group: [3, 5, 6]
    },
    {
      id: 9,
      name: "Ingmar",
      lastName: "Vali",
      city: "Tallinn",
      birthday: "12.12.1212",
      group: [1, 2, 3]
    },
    {
      id: 10,
      name: "Rauno",
      lastName: "Kulla",
      city: "Tallinn",
      birthday: "20.05.1991",
      group: [2, 3, 5]
    },
    {
      id: 11,
      name: "Roxana",
      lastName: "Dina",
      city: "Geneva",
      birthday: "12.12.1212",
      group: [3, 5, 6]
    },
    {
      id: 12,
      name: "Kamil",
      lastName: "Gruca",
      city: "Poland",
      birthday: "12.12.1212",
      group: [1]
    },
  ];
  groupsList = [
    {
      id: 1,
      name: "Business User"
    },
    {
      id: 2,
      name: "Part B Operator"
    },
    {
      id: 3,
      name: "Notary"
    },
    {
      id: 4,
      name: "TCB",
      unit: "Clearance Unit"
    },
    {
      id: 5,
      name: "Institution X",
      unit: "Unit Y"
    },
    {
      id: 6,
      name: "Institution Z"
    }
  ];
  servicesList = [
    {
      id: 1,
      name: "Business Licence"
    },
    {
      id: 2,
      name: "Tour Operator"
    }
  ];
  businessEntityList = [
    {
      id: 1,
      name: "Bhutan Tours Ltd"
    },
    {
      id: 2,
      name: "Tashi Dorji"
    }
  ];

  public switchPanelTab(target, value) {
    switch (target) {
      case "users-panel":
        this.currentUserPanelTab = value;
        break;
      case "content-panel":
        this.currentContentPanelTab = value;
        break;
    }
  }
  public selectUser(user) {
    this.userIsActive = true;
    this.groupIsActive = false;
    this.activeUser = user;
    this.activeGroup = {};
    this.userInfoActive = false;
    this.groupInfoActive = false;
  }
  public selectGroup(group) {
    this.groupIsActive = true;
    this.userIsActive = false;
    this.activeGroup = group;
    this.activeUser = {};
    this.userInfoActive = false;
    this.groupInfoActive = false;
  }
  public userInfo(user) {
    this.userIsActive = true;
    this.activeUser = user;
    this.userInfoActive = true;
    this.groupIsActive = false;
    this.activeGroup = {};
    this.groupInfoActive = false;
  }
  public groupInfo(group) {
    this.groupIsActive = true;
    this.activeGroup = group;
    this.groupInfoActive = true;
    this.activeGroup.users = this.usersInGroup();
  }
  public usersInGroup() {
    const _this = this;
    const returnList = this.usersList.map((obj) => {
      if (obj.group.indexOf(_this.activeGroup.id) !== -1) {
        return obj;
      }
    });
    const filtered = returnList.filter((el) => {
      return el != null || el !== undefined;
    });
    return filtered;
  }
  public toggleUserCASImport() {
    this.userCASImportActive = !this.userCASImportActive;
  }
}
